import { inject } from 'mobx-react';
import * as React from 'react';

import { ViewMedium, Viewport, ViewSmall } from 'bernie-view';

import { CurrentHotelStore } from 'stores/current-hotel-store';

import { RatePlanViewModel, RoomViewModel } from 'models';

import { classNames } from 'uitk-react-utils';

import { LazyLoadRatePlans } from 'src/common/components/infosite/rooms-and-rates/rate-plans/internals/lazy-load-rate-plans';
import { roomRatePlansWrapperLoadable } from 'components/infosite/rooms-and-rates/loadable';

const RatePlansWrapperLoadable = roomRatePlansWrapperLoadable.codeSplit as any;

export interface RoomRateOptionsProps {
  id: string;
  isUnavailable?: boolean;
  position: string;
  excludeReserveButton?: boolean;
  ratePlanCollection?: RatePlanViewModel[];
  room: RoomViewModel;
  trackingRfrr?: string;
  isPinnedRatePlan?: boolean;
  optionBaseIndex?: number;
  excludePriceBreakDownLink?: boolean;
  currentHotel?: CurrentHotelStore;
  layerId?: string;
}

export interface RoomRateOptionsState {
  jsEnabled: boolean;
}

@inject('currentHotel')
export class RoomRateOptions extends React.Component<RoomRateOptionsProps, RoomRateOptionsState> {
  constructor(props: RoomRateOptionsProps) {
    super(props);
    this.state = {
      jsEnabled: false,
    };
  }

  public componentDidMount() {
    this.setState({
      jsEnabled: true,
    });
  }

  public render() {
    const {
      ratePlanCollection,
      currentHotel,
      excludeReserveButton,
      id,
      isUnavailable,
      position,
      room,
      trackingRfrr,
      isPinnedRatePlan,
      optionBaseIndex = 0,
      excludePriceBreakDownLink,
      layerId,
    } = this.props;

    if (!ratePlanCollection || ratePlanCollection.length === 0) {
      return null;
    }

    const roomRatesDefaultProps = {
      excludeReserveButton,
      id,
      isUnavailable,
      position,
      ratePlanCollection,
      room,
      trackingRfrr,
      isPinnedRatePlan,
      optionBaseIndex,
      excludePriceBreakDownLink,
      layerId,
    };

    const additionalClass = classNames({ 'all-l-padding-three': currentHotel?.canDisplayMultipleRatePlansInline });

    return (
      <Viewport>
        <ViewSmall>
          <LazyLoadRatePlans
            jsEnabled={this.state.jsEnabled}
            ratePlanCollection={ratePlanCollection}
            roomRatesDefaultProps={roomRatesDefaultProps}
          />
        </ViewSmall>
        <ViewMedium>
          <RatePlansWrapperLoadable {...roomRatesDefaultProps} additionalClass={additionalClass} />
        </ViewMedium>
      </Viewport>
    );
  }
}
